<template>
    <div class="x-model-view">
        <x-title-view
            v-if="config.title"
            :config="config?.title"
            :query-params="queryParams"
            @close="()=>close()"
            :proxy="proxy"
            :pcode="getFullCode()"
            :help="helpUrl"
        ></x-title-view>
        <el-container>
            <el-aside v-if="config.tree" style="position:absolute; height:calc(100vh - 140px); min-height: 600px;">
                <el-scrollbar class="scroll" height="100%">
                    <x-filter-view
                        :config="getTreeConfig(config)"
                        :query-params="queryParams"
                        :view-state="viewState"
                        :code="config.name"
                        :proxy="proxy"
                        :filter-data="filterData"
                        :pcode="getFullCode()"
                    ></x-filter-view>
                </el-scrollbar>
            </el-aside>
            <el-container :style="`${config.tree ? 'margin-left:300px;' : ''} min-height:calc(100vh - 140px)`">
                <el-header style="padding:0; height:auto;">
                    <x-query-view
                        v-if="config.query"
                        :config="config?.query"
                        :code="config.name"
                        :query-params="queryParams"
                        :proxy="proxy"
                        :filter-data="filterData"
                        :pcode="getFullCode()"
                    ></x-query-view>
                </el-header>
                <el-container style="background:#fff;">
                    <el-aside v-if="config.aside"></el-aside>
                    <el-main style="padding:0;">
                        <x-form-view
                            :config="config?.body"
                            :query-params="queryParams"
                            :view-state="viewState"
                            :code="config.name"
                            :proxy="proxy"
                            :filter-data="filterData"
                            :pcode="getFullCode()"
                        ></x-form-view>
                    </el-main>
                </el-container>
            </el-container>
        </el-container>
    </div>
</template>
<script>
</script>
<script setup>
import { getCurrentInstance, reactive, ref, watch } from 'vue';
import PageType from './PageType';
import XQueryView from './XQueryView.vue';
import XTitleView from './XTitleView.vue';
import XFormView from './XFormView.vue';
import XFilterView from './XFilterView.vue';
import { useRoute } from 'vue-router';
import { getRouteInfo } from '../router/RouterMap';
import axios from 'axios';
import { useTokenStore } from '../store/TokenStore';
import { dayjs } from 'element-plus';
import TimeService from '../remoteservice/TimeService';

const inst = getCurrentInstance();

const token = useTokenStore();

const props = defineProps({
    config: { default: null },
    keyData: { default: null },
    showType: { default: PageType.PAGE },
    viewState: { default: null },

    proxy: { default: null },

    pcode: { default: null },
})

const filterData = ref({_r:null, data:null, module:null});

const getTreeConfig = (config)=> {
    // console.log(config);
    if (!config.tree.targetModule) config.tree.targetModule = config.query.view.getModuleCode();
    return config.tree;
}

const helpUrl = ref(null);
const route = useRoute();
const getGetHelpFile = async (path)=> {
    const p = path.replace(/\/(tat|ebk|system)/, '');
    const {mode, route} = getRouteInfo(p);
    const url = '/help/' + route.module + '/' + mode + '/help.html';
    (await axios.get(url).catch((e)=>e))
    helpUrl.value = url;
}
getGetHelpFile(route.path.replace(/\/\_[^\/]*?$/, ''));

defineEmits({
    'close': null,
})

const closed = ref(false);
const close = ()=> {
    closed.value = true;
    inst.emit('close');
}

// const pageConfig = ref(null);
// watch(()=> props.config, (value)=> {
//     pageConfig.value = PageFlowEngine.transformConfig(value);
// }, {immediate:true})

// const getConfig = (config)=> {
//     console.log('page config', config)
//     const conf = (config instanceof ViewConfig) ? config : ViewConfig.createViewConfig(config);
//     return conf;
// }
const queryParams = ref(null);

const getFilter = (filter)=> {
    if (!filter) return {query:{}, options:null};
    const query = {};
    const options = {};
    for (const [key, value] of Object.entries(filter)) {
        if (value instanceof Object && !(value instanceof Array)) {
            if (value.in) {
                query[key] = value.in.split(/\s*\.\s*/).reverse();
                options[key] = 'relate-in';
            } else if (value.not) {
                query[key] = value.not.split(/\s*\,\s*/).reverse();
                options[key] = 'notin';
            } else if (value.notin) {
                query[key] = value.notin.split(/\s*\.\s*/).reverse();
                options[key] = 'relate-notin';
            } else if (value.relate) {
                query[key] = value.relate;
                options[key] = 'multi-relate';
            }
        } else {
            query[key] = value;
        }
    }
    return {query:query, options:options};
}
const getQuery = (queryConfig, data)=> {
    if (!queryConfig) return {};
    const query = {};
    const options = {};
    queryConfig = queryConfig.replace(/([\w\,\.\:]+?)\?(?:\{(\w+)\}|([\w\'\"]+))/g, ($0, $1, $2, $3)=> {
        let keys = $1;
        let o = $2 || null;
        let ov = null;
        switch (o) {
            case null: ov = null; break;
            case 'loginUser': ov = token.userid; break;
            case 'loginUserName': ov = token.username; break;
            case 'now': ov = dayjs(TimeService.getServerTimeStamp()).format('YYYY-MM-DD HH:mm:ss'); break;
            default: ov = data[o];
        }
        const r = $3 != null ? $3.replace(/\'/g, '"') : null;
        let v = r != null ? JSON.parse(r) : ov;
        if (v == null) v = '';
        keys = keys.split(/[\,\.\:]/);
        let key = keys.shift();
        while(query[key]) key += '+';
        const value = [keys, ['' + v]];
        query[key] = value;
        options[key] = 'multi-relate';
        return '';
    })
    queryConfig = queryConfig.replace(/(\w+)(\=|\>|\<)(?:\{(\w+)\}|([\w\'\"]+))/g, ($0, $1, $c, $2, $3)=> {
        const c = $c;
        let key = $1;
        while(query[key]) key += '+';
        let o = $2 || null;
        let ov =  null;
        switch (o) {
            case null: ov = null; break;
            case 'loginUser': ov = token.userid; break;
            case 'loginUserName': ov = token.username; break;
            case 'now': ov = dayjs(TimeService.getServerTimeStamp()).format('YYYY-MM-DD HH:mm:ss'); break;
            default: ov = data[o];
        }
        const r = $3 != null ? $3.replace(/\'/g, '"') : null;
        let v = r != null ? JSON.parse(r) : ov;
        if (c == '=') {
            if (v != null) query[key] = v;
        } else if (c == '>') {
            if (v != null) {
                if (!query[key]) query[key] = [v, null];
                else query[key][0] = v;
            }
            options[key] = 'range';
        } else if (c == '<') {
            if (v != null) {
                if (!query[key]) query[key] = [null, v];
                else query[key][1] = v;
            }
            options[key] = 'range';
        }
        
        return '';
    })
    queryConfig = queryConfig.replace(/(\w+)\=([^\s\&]+)/g, ($0, $1, $2)=> {
        const key = $1
        let value = $2.split(/\s*\,\s*/);
        value = value.map((v)=>JSON.parse(v));
        if (value.length == 1) value = value[0];
        query[key] = value;
        return '';
    })
    return {query:query, options:options};
}

const f = getFilter(props.config?.filter);
const def = getQuery(props.config?.condition, props.keyData);
queryParams.value = {query:Object.assign({}, f?.query, def?.query), options:Object.assign({}, f?.options, def?.options)};
// const queryParams = reactive(getFilter(props.config?.filter));

const getFullCode = ()=> {
    // return (props.pcode || '') + (props.config.code ? ('page/' + props.config.code + '/') : '');
    return props.pcode;
}

</script>
<style scoped>
    .xm-seize-a-seat{
        background: #fff;
        height: 5px;
    }
    .x-model-view >>> .scroll {
        overflow: hidden;
        position: relative;
        height: calc(100% - 10px);
        margin-top: 10px;
        margin-right: 10px;
        padding-left: 10px;
        background: #FFF;
    }
</style>